<template>
    <header class="header-global">
        <base-nav class="navbar-main" transparent type="" effect="light" expand>
            <router-link slot="brand" class="navbar-brand mr-lg-5" to="/">
                <img src="img/brand/logo_svg_white-01.svg" alt="logo">
            </router-link>

            <div class="row" slot="content-header" slot-scope="{closeMenu}">
                <div class="col-6 collapse-brand">
                    <a href="/">
                        <img src="img/brand/quality_logo_black.svg">
                    </a>
                </div>
                <div class="col-6 collapse-close">
                    <close-button @click="closeMenu"></close-button>
                </div>
            </div>

            <!-- <ul class="navbar-nav navbar-nav-hover align-items-lg-center">
                <base-dropdown class="nav-item" menu-classes="dropdown-menu-xl">
                    <a slot="title" href="#" class="nav-link" data-toggle="dropdown" role="button">
                        <i class="ni ni-ui-04 d-lg-none"></i>
                        <span class="nav-link-inner--text">About</span>
                    </a>
                    <div class="dropdown-menu-inner">
                        <a href="https://demos.creative-tim.com/vue-argon-design-system/documentation/"
                           class="media d-flex align-items-center">
                            <div class="icon icon-shape bg-gradient-primary rounded-circle text-white">
                                <i class="ni ni-spaceship"></i>
                            </div>
                            <div class="media-body ml-3">
                                <h6 class="heading text-primary mb-md-1">Project</h6>
                                <p class="description d-none d-md-inline-block mb-0">Get started with Bootstrap, the
                                    world's most popular framework for building responsive sites.</p>
                            </div>
                        </a>
                        <a href="https://demos.creative-tim.com/vue-argon-design-system/documentation/"
                           class="media d-flex align-items-center">
                            <div class="icon icon-shape bg-gradient-warning rounded-circle text-white">
                                <i class="ni ni-ui-04"></i>
                            </div>
                            <div class="media-body ml-3">
                                <h5 class="heading text-warning mb-md-1">Partners</h5>
                                <p class="description d-none d-md-inline-block mb-0">Learn how to use Argon
                                    compiling Scss, change brand colors and more.</p>
                            </div>
                        </a>
                    </div>
                </base-dropdown>
                <li class="nav-item">
                    <router-link to="/register" class="nav-link">
                        <span class="nav-link-inner--text">European Development Plan</span>
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/register" class="nav-link">
                        <span class="nav-link-inner--text">Guidance for Stakeholders</span>
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/register" class="nav-link">
                        <span class="nav-link-inner--text">Standards</span>
                    </router-link>
                </li>
            </ul> -->
            <ul class="navbar-nav align-items-lg-center ml-lg-auto">
                <!-- <base-dropdown class="nav-item" menu-classes="dropdown-menu-xl">
                    <a slot="title" href="#" class="nav-link" data-toggle="dropdown" role="button">
                        <i class="ni ni-ui-04 d-lg-none"></i>
                        <span class="nav-link-inner--text">About</span>
                    </a>
                    <div class="dropdown-menu-inner">
                        <a href="/#backgrd"
                           class="media d-flex align-items-center">
                            <div class="icon icon-shape bg-gradient-primary rounded-circle text-white">
                                <i class="ni ni-spaceship"></i>
                            </div>
                            <div class="media-body ml-3">
                                <h6 class="heading text-primary mb-md-1">Project</h6>
                                <p class="description d-none d-md-inline-block mb-0">Get started with Bootstrap, the
                                    world's most popular framework for building responsive sites.</p>
                            </div>
                        </a>
                        <router-link to="'/' + '#backgrd'" class="media d-flex align-items-center">
                            <div class="icon icon-shape bg-gradient-primary rounded-circle text-white">
                                <i class="ni ni-spaceship"></i>
                            </div>
                            <div class="media-body ml-3">
                                <h6 class="heading text-primary mb-md-1">Project</h6>
                                <p class="description d-none d-md-inline-block mb-0">The Online Course for Teachers gives a deeper understanding of mobility projects for VET learners within the Erasmus+ programme and explains what the teacher’s key roles and responsibilities.</p>
                            </div>
                        </router-link>
                        <router-link to="/partners" class="media d-flex align-items-center">
                            <div class="icon icon-shape bg-gradient-warning rounded-circle text-white">
                                <i class="ni ni-ui-04"></i>
                            </div>
                            <div class="media-body ml-3">
                                <h5 class="heading text-warning mb-md-1">Partners</h5>
                                <p class="description d-none d-md-inline-block mb-0">Learn how to use Argon
                                    compiling Scss, change brand colors and more.</p>
                            </div>
                        </router-link>
                    </div>
                </base-dropdown> -->
                <li class="nav-item">
                    <router-link to="/partners" class="nav-link">
                        <span class="nav-link-inner--text">Partners</span>
                    </router-link>
                </li>
                 <base-dropdown class="nav-item" menu-classes="dropdown-menu-xl">
                    <!-- <a slot="title" href="#" class="nav-link" data-toggle="dropdown" role="button"> -->
                        <!-- <i class="ni ni-ui-04 d-lg-none"></i> -->
                        <!-- <span class="nav-link-inner--text">Guidance for Stakeholders</span> -->
                        <router-link to="/standards" class="nav-link" slot="title" data-toggle="dropdown" role="button">
                            <span class="nav-link-inner--text">Standards</span>
                        </router-link>
                    <!-- </a> -->
                    <div class="dropdown-menu-inner">
                        <a href="https://firebasestorage.googleapis.com/v0/b/adeptprod-11172.appspot.com/o/docs%2FQ%2B_Memorandum_Digital_Form.pdf?alt=media&token=8eb7b82d-4cd8-422a-a3eb-889ed6876784" target="_BLANK"
                           class="media d-flex align-items-center">
                            <div class="icon icon-shape bg-blue rounded-circle text-white">
                                <i class="ni ni-cloud-download-95"></i>
                            </div>
                            <div class="media-body ml-3">
                                <h6 class="heading text-blue mb-md-1">Memorandum of Understanding between the School and Intermediary Organisation</h6>
                                <p class="description d-none d-md-inline-block mb-0">The Memorandum of Understanding (MoU) applies when the VET mobility is implemented in cooperation with an Intermediary Organisation (IO).</p>
                            </div>
                        </a>
                        <a href="https://firebasestorage.googleapis.com/v0/b/adeptprod-11172.appspot.com/o/docs%2FStudent_Commitment_Form_FINAL.pdf?alt=media&token=a6baadba-f2a6-4388-bcb2-183a6befc502"
                           target="_BLANK" class="media d-flex align-items-center">
                            <div class="icon icon-shape bg-blue rounded-circle text-white">
                                <i class="ni ni-hat-3"></i>
                            </div>
                            <div class="media-body ml-3">
                                <h6 class="heading text-blue mb-md-1">Student Commitment Form</h6>
                                <p class="description d-none d-md-inline-block mb-0">The Student Commitment Form targets the learners who undertakes a VET mobility and it urges the learner to reflect on their responsibilities before, during and after the mobility. The standard can be adjusted to reflect any particularity.</p>
                            </div>
                        </a>
                        <a href="https://firebasestorage.googleapis.com/v0/b/adeptprod-11172.appspot.com/o/docs%2FStudentProfileForm_Final.pdf?alt=media&token=ac07f0dd-3657-44fb-a499-a319e991a314"
                           target="_BLANK" class="media d-flex align-items-center">
                            <div class="icon icon-shape bg-blue rounded-circle text-white">
                                <i class="ni ni-hat-3"></i>
                            </div>
                            <div class="media-body ml-3">
                                <h6 class="heading text-blue mb-md-1">Student Profile Form</h6>
                                <p class="description d-none d-md-inline-block mb-0">The Student Profile Form a template to present to present the Host Companies the learner’s practical experience, skills, and learning objectives.</p>
                            </div>
                        </a>

                        <a href="https://firebasestorage.googleapis.com/v0/b/adeptprod-11172.appspot.com/o/docs%2FQ%2B_HostCompaniesDiplomas.zip?alt=media&token=e1a4d03a-19b4-414e-ac27-1d62b193e1d9"
                           target="_BLANK" class="media d-flex align-items-center">
                            <div class="icon icon-shape bg-blue rounded-circle text-white">
                                <i class="ni ni-books"></i>
                            </div>
                            <div class="media-body ml-3">
                                <h6 class="heading text-blue mb-md-1">Standard Diploma for Host Companies</h6>
                                <p class="description d-none d-md-inline-block mb-0">The Standard Diploma for Host Companies can be used by IOs or sending institutions to recognise the efforts of Host Companies.</p>
                            </div>
                        </a>
                    </div>
                </base-dropdown>
                <!-- <li class="nav-item">
                    <router-link to="/register" class="nav-link">
                        <span class="nav-link-inner--text">Guidance for Stakeholders</span>
                    </router-link>
                </li> -->
                 <base-dropdown class="nav-item" menu-classes="dropdown-menu-xl">
                    <!-- <a slot="title" href="#" class="nav-link" data-toggle="dropdown" role="button"> -->
                        <!-- <i class="ni ni-ui-04 d-lg-none"></i> -->
                        <!-- <span class="nav-link-inner--text">Guidance for Stakeholders</span> -->
                        <router-link to="/guidance" class="nav-link" slot="title" data-toggle="dropdown" role="button">
                            <span class="nav-link-inner--text">Guidance for Stakeholders</span>
                        </router-link>
                    <!-- </a> -->
                    <div class="dropdown-menu-inner">
                        <a href="#" @click="show"
                           class="media d-flex align-items-center">
                            <div class="icon icon-shape bg-green rounded-circle text-white">
                                <i class="ni ni-hat-3"></i>
                            </div>
                            <div class="media-body ml-3">
                                <h6 class="heading text-green mb-md-1">Online Guide for Teachers</h6>
                                <p class="description d-none d-md-inline-block mb-0">The Online Guide for Teachers gives a deeper understanding of mobility projects for VET learners within the Erasmus+ programme and explains what the teacher’s key roles and responsibilities.</p>
                            </div>
                        </a>
                        <a href="https://firebasestorage.googleapis.com/v0/b/adeptprod-11172.appspot.com/o/docs%2Ffinal%2FQ%2B_GuideforHC_A5_Digital_Final.pdf?alt=media&token=b66cd00f-6548-434b-ba35-5377a74057c9"
                           target="_BLANK" class="media d-flex align-items-center">
                            <div class="icon icon-shape bg-blue rounded-circle text-white">
                                <i class="ni ni-cloud-download-95"></i>
                            </div>
                            <div class="media-body ml-3">
                                <h6 class="heading text-blue mb-md-1">Guide for Host Companies</h6>
                                <p class="description d-none d-md-inline-block mb-0">The Guide for Host Companies answers 77 questions that a host company may have in order to manage a VET traineeship before, during and after it takes place. </p>
                            </div>
                        </a>
                        <a href="https://firebasestorage.googleapis.com/v0/b/adeptprod-11172.appspot.com/o/docs%2FQ%2B_Checklist_A4_OfficePrint_Final.pdf?alt=media&token=f34a5c3c-fd28-470e-b4a8-f190a6e96a22"
                           target="_BLANK" class="media d-flex align-items-center">
                            <div class="icon icon-shape bg-green rounded-circle text-white">
                                <i class="ni ni-cloud-download-95"></i>
                            </div>
                            <div class="media-body ml-3">
                                <h6 class="heading text-green mb-md-1">Check List for IOs</h6>
                                <p class="description d-none d-md-inline-block mb-0">The Check List give the intermediary organisation an overview of the most important aspect to discuss with host companies when planning a VET traineeship.</p>
                            </div>
                        </a>
                        <a href="https://firebasestorage.googleapis.com/v0/b/adeptprod-11172.appspot.com/o/docs%2FQ%2B_Students_Brochure_Trifold_Print_Final.pdf?alt=media&token=8801d0fe-3691-4bf0-aa64-9f3528b0cb7a"
                           target="_BLANK" class="media d-flex align-items-center">
                            <div class="icon icon-shape bg-red rounded-circle text-white">
                                <i class="ni ni-books"></i>
                            </div>
                            <div class="media-body ml-3">
                                <h6 class="heading text-red mb-md-1">VET Learners Brochure</h6>
                                <p class="description d-none d-md-inline-block mb-0">The VET Learners Brochure presents the VET traineeship and target to the learners</p>
                            </div>
                        </a>
                        <a href="https://firebasestorage.googleapis.com/v0/b/adeptprod-11172.appspot.com/o/docs%2FQ%2B_HC_Brochure_Trifold_Print_Final.pdf?alt=media&token=f7836162-8440-4491-b3e3-b3d6040e8a91"
                           target="_BLANK" class="media d-flex align-items-center">
                            <div class="icon icon-shape bg-blue rounded-circle text-white">
                                <i class="ni ni-books"></i>
                            </div>
                            <div class="media-body ml-3">
                                <h6 class="heading text-blue mb-md-1">Host Companies Brochure</h6>
                                <p class="description d-none d-md-inline-block mb-0">The Host Companies Brochure presents the VET traineeship and target to the Host Companies.</p>
                            </div>
                        </a>
                    </div>
                </base-dropdown>
                <li class="nav-item">
                    <router-link to="/edp" class="nav-link">
                        <span class="nav-link-inner--text">European Development Plan</span>
                    </router-link>
                </li>
                <li class="nav-item d-none d-lg-block ml-lg-4 success">
                    <a href="https://adeptprod-11172.web.app/" rel="noopener"
                       class="btn btn-neutral btn-icon outline success">
                <span class="btn-inner--icon">
                  <i class="fa fa-code mr-2"></i>
                </span>
                        <span class="nav-link-inner--text">IT Tool</span>
                    </a>
                </li>
            </ul>
        </base-nav>
            <modal height="auto" width="80%" name="my-second-modal">
                        <div>
                            <div class="player-container">
                                <Media 
                                    :kind="'video'"
                                    :controls="true"
                                    :src="['https://firebasestorage.googleapis.com/v0/b/adeptprod-11172.appspot.com/o/docs%2Ffinal%2FOnline%20Guide%20for%20Teachers_VIDEO.mp4?alt=media&token=49266a73-f5d8-4d0b-b1d0-99e71e8c162d']"
                                    :style="{width: '100%'}"
                                    :autoplay="true"
                                    :loop="false"
                                >
                                </Media>
                            </div>
                        </div>
            </modal>
    </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";
import Media from '@dongido/vue-viaudio';

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown,
    Media
  },
  methods: {
        show () {
         this.$modal.show('my-second-modal');
        },
        hide () {
         this.$modal.hide('my-second-modal');
    },
  },
};
</script>
<style>

#app > header > nav > div {
    max-width: 1200px !important;
}
.dropdown-menu-xl {
    min-width: 480px !important;
}
.bg-yellow {
    background: #EEE821; 
}
.bg-red {
    background: #DC6568;
}
.bg-green {
    background: #82c391;
}
.bg-blue {
    background: #54ADE1;
}
.text-yellow {
    color: #EEE821; 
}
.text-red {
    color: #DC6568;
}
.text-green {
    color: #82c391;
}
.text-blue {
    color: #54ADE1;
}
</style>
